module.exports = __webpack_public_path__ + "9b30f13428e1b4a659aeeab4ac1fff35.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Italic/OpenSans-Italic.ttf?v=1.1.0
// module id = 990
// module chunks = 0